import { render, staticRenderFns } from "./updata-device.vue?vue&type=template&id=e8486c16"
import script from "./updata-device.vue?vue&type=script&lang=js"
export * from "./updata-device.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8486c16')) {
      api.createRecord('e8486c16', component.options)
    } else {
      api.reload('e8486c16', component.options)
    }
    module.hot.accept("./updata-device.vue?vue&type=template&id=e8486c16", function () {
      api.rerender('e8486c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/updata-device.vue"
export default component.exports